import { ThunkApiType } from 'types/utils';
import { download } from 'utils/download';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

export const downloadFileThunk = async (
	{
		url,
		fileName,
		allowDownload,
	}: {
		url: string;
		fileName: string;
		allowDownload: boolean;
	},
	thunkAPI: ThunkApiType,
) => {
	try {
		const response = await authFetch.get(url, {
			responseType: 'blob',
		});

		if (allowDownload) {
			download(response.data, fileName);
			return true;
		}

		return { blob: response.data, fileName };
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
